import React, { useImperativeHandle, useRef, useState } from "react";
import { Close } from "@monta/icons";
import { Button, Modal, useModal } from "@monta/design-system";
import styles from "./ConfirmationModal.module.scss";

export type TConfirmationModalRef = {
  open: (cb: (value: number) => void) => void;
};

const ConfirmationModal = React.forwardRef<TConfirmationModalRef>(
  (props, ref) => {
    const controller = useModal();
    const callbackRef = useRef<((value: number) => void) | undefined>();
    const [confirmationTakingId, setConfirmationTakingId] = useState("");

    const handleClose = () => {
      setConfirmationTakingId("");
      controller.close();
    };

    const handleChange = (e) => {
      setConfirmationTakingId(e.target.value);
    };

    useImperativeHandle(ref, () => ({
      open(cb: (value: number) => void) {
        callbackRef.current = cb || (() => controller.close());
        controller.open();
      }
    }));

    return (
      <Modal {...controller} className={styles["modal"]} close={handleClose}>
        <div>
          تائید منتا <Close onClick={handleClose} color="#8C8787" />
        </div>
        <p className="!my-4">آیا از تائید آزمون اطمینان دارید؟</p>
        <div
          className={
            "flex items-center rounded-md border border-[#e2e8f0] px-3 py-2 gap-3"
          }
        >
          <input
            type="number"
            value={confirmationTakingId}
            onChange={handleChange}
            placeholder={"کد اجرا را وارد کنید"}
            className={
              "bg-transparent border-none outline-none !text-xs flex-1 text-neutral-600"
            }
          />
        </div>
        <Button
          onClick={() => {
            callbackRef.current?.(Number(confirmationTakingId));
            handleClose();
          }}
          className="mt-4"
          disabled={confirmationTakingId === ""}
        >
          تایید
        </Button>
      </Modal>
    );
  }
);

export default ConfirmationModal;

ConfirmationModal.displayName = "ConfirmationModal";
